//////////////////////////////////////////////////////
/// DO NOT EDIT                                    ///
/// Generated by Trygghetsfonden.Dataverse.Tools   ///
/// Source file: xrm.context.include.txt           ///
//////////////////////////////////////////////////////

export enum tsl_loggtyp {
	Epost = 1,
	Telefonsamtal = 2,
	SMS = 3,
	Postalttelefonepostsaknas = 4,
	PostaltAvvaktakomplettering = 5,
	Videosamtal = 866190000,
	PostaltJagskickarbrev = 866190001,
	VlkomstbrevUnder40 = 866190100,
	Vlkomstbrevver40 = 866190200,
	PostaltKonkurs = 866190201,
};
